var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadE(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 346.21,
    height: 469.79,
    viewBox: "0 0 346.21 469.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218,10.11v99.23c.17,1.87,1.44,12.69,15.46,20.65,13.85,7.86,29.79,7.06,32.65,6.88h94.5",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157,479.89V380.66c-.17-1.87-1.44-12.69-15.46-20.65-13.85-7.86-29.79-7.06-32.65-6.88H14.39",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.61,179.9H268.68c-3.61-.08-20.21-.15-34.36,8.31C218.45,197.7,218,210.53,218,212.59v267.3",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.39,310.1h91.93c3.61.08,20.21.15,34.36-8.31,15.87-9.49,16.3-22.32,16.32-24.38V10.11",
    transform: "translate(-14.39 -10.11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadE);
export default __webpack_public_path__ + "static/media/road-E.a322c6cf377d94cf3d8c9fb99f995f9b.svg";
export { ForwardRef as ReactComponent };